import { render, staticRenderFns } from "./invoice-history.vue?vue&type=template&id=73a0afea&"
import script from "./invoice-history.vue?vue&type=script&lang=js&"
export * from "./invoice-history.vue?vue&type=script&lang=js&"
import style0 from "./invoice-history.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports